module.exports = __webpack_public_path__ + "media/34.ce023870.wav";